export default {
  namespaced: true,
  state     : {
    rating_companies: {
      content: {
        search    : '',
        pagination: {
          sortBy     : 'id',
          rowsPerPage: 10,
          page       : 1,
        },
        headers: [
          {text: 'Курс', value: 'name'},
          {text: 'Дата постановки', value: 'statement_date'},
          {text: 'Статус ', value: 'status'},
          {text: 'Пройдено ', value: 'completed_percent'},
          {text: 'Ср. балл', value: 'average_users_points'},
          // {
          //   text       : 'Результаты теста',
          //   value      : '',
          //   inner_items: [
          //     {
          //       text : 'Выше порога',
          //       value: 'test_passed',
          //     },
          //     {
          //       text : 'Ниже порога',
          //       value: 'test_not_passed',
          //     },
          //     {
          //       text : 'Ср. балл',
          //       value: 'test_average',
          //     },
          //   ],
          // },
          {text: 'Времени затрачено ', value: 'average_users_time'},
        ],
        body: [],
      },
    },
  },
  getters: {
    rating_companies: ({rating_companies}) => rating_companies,
  },
  mutations: {
    SET_PAGINATION(state, value) {
      state.rating_companies.content.pagination = {
        ...state.rating_companies.content.pagination,
        ...value,
      };
    },
    SET_COMPANY_PAGE(state, value) {
      let table = state.rating_companies.content;
      table.pagination.page = value;
    },
    SET_COMPANIES(state, value) {
      state.rating_companies.content.body = value;
    },
    SHOW_ORG_NUMBER(state, selected) {
      let table = state.rating_companies.content;

      if (selected == 'Показывать по 10') {
        table.pagination.rowsPerPage = 10;
      } else if (selected == 'Показывать по 25') {
        table.pagination.rowsPerPage = 25;
      } else if (selected == 'Показывать по 50') {
        table.pagination.rowsPerPage = 50;
      } else if (selected == 'Показывать по 100') {
        table.pagination.rowsPerPage = 100;
      }
    },
  },
  actions: {
    async change_organization_per_page({commit}, event) {
      commit('SHOW_ORG_NUMBER', event);
      commit('SET_COMPANY_PAGE', 1);
    },
  },
};
